import React, { useRef, useEffect, useState, useContext } from "react";
import Phaser from "phaser";
import { gameConfig } from "../game";
import { keyList } from "../library/keyList";
import { DynamicScene } from "../game/scenes/dynamicScene/dynamic";

import ErrorBoundary from "./ErrorBoundary";
import { ReceivedInputTextBox } from "./ReceivedInputTextBox";
import SendInputTextBox from "./SendInputTextBox";
import { CharacterChatTextBox } from "./CharacterChatTextBox";
import { Missions } from "./Missions";
import { Nail } from "./Nail";
import InteractiveOverlay from "./InteractiveOverlay";
import CurrentMissionContext from "./CurrentMissionContext";

import { getFirestore, collection, addDoc } from "firebase/firestore";

import "./css/Login.css";

function Game() {
  const gameRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  // const [idKey, setIdKey] = useState(localStorage.getItem("idKey") || "");

  const [currentMission, setCurrentMission] = useState(null);

  const [forceRerender, setForceRerender] = useState(Date.now());

  const [emailError, setEmailError] = useState("");

  const db = getFirestore();

  useEffect(() => {
    console.log("GAME IS REFRESHED", forceRerender);
    const gameCanvas = document.getElementById("phaser-game");
    if (gameCanvas) {
      gameCanvas.innerHTML = "";
    }

    const config = Object.assign(
      {
        type: Phaser.AUTO,
        parent: gameRef.current,
        width: 800,
        height: 600,
        scene: [DynamicScene],
      },
      gameConfig
    );

    const game = new Phaser.Game(config);
    window.gameInstance = game;
    // console.log("Phaser gameInstance is now set up.");

    if (game) {
      setIsReady(true);
      // console.log("React isReady is now set to true.");
    } else {
      console.log("Phaser gameInstance is null!!!");
    }

    // game.events.emit('changeMission', currentMission);
    // console.log("currentMission is now set to " + currentMission);

    // const textUpdateHandler = (newText) => {
    //   setTextBoxText(newText);
    // }

    // window.gameInstance.events.on('update-text', textUpdateHandler);

    return () => {
      game.destroy(true);
      // window.gameInstance.events.off('update-text', textUpdateHandler);
    };
  }, [currentMission, forceRerender]);

  // const handleKeyDown = async (event) => {
  //   event.stopPropagation();
  //   if (event.key === "Enter") {
  //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //     const email = event.target.value;
  //     if (emailRegex.test(email)) {
  //       setEmailError("");
  //       localStorage.setItem("idKey", "olivia");
  //       setIdKey("olivia");

  //       // Add email to Firestore
  //       try {
  //         await addDoc(collection(db, "Emails"), { email: email });
  //       } catch (error) {
  //       }
  //     } else {
  //       setEmailError("Please enter a valid email address");
  //     }
  //   }
  // };

  return (
    <>
      <CurrentMissionContext.Provider value={currentMission}>
        <>
          <ErrorBoundary>
            <div>
              <InteractiveOverlay />
            </div>
          </ErrorBoundary>
          <ErrorBoundary>
            <div>
              <Missions />
            </div>
          </ErrorBoundary>
          <ErrorBoundary>
            <div>
              <Nail />
            </div>
          </ErrorBoundary>
          <ErrorBoundary>
            <div>
              <div ref={gameRef} />
            </div>
          </ErrorBoundary>
          {isReady && (
            <ErrorBoundary>
              <ReceivedInputTextBox />
            </ErrorBoundary>
          )}
          {isReady && (
            <ErrorBoundary>
              <SendInputTextBox />
            </ErrorBoundary>
          )}
          {isReady && (
            <ErrorBoundary>
              <CharacterChatTextBox />
            </ErrorBoundary>
          )}
        </>
      </CurrentMissionContext.Provider>
    </>
  );
}

export default Game;
